module.exports = __webpack_public_path__ + "img/store_vip_benefit_packs.223d97ab.png";